import React from "react";
import { MyContext } from '../../InitialSetup/MyProvider';
import MatchInfo from "./MatchInfo";
import { Utilities } from "../../Utilities/Utilities";
import * as AppLabels from "../../helper/AppLabels";
import { MATCH_TYPE ,SELECTED_GAMET} from "../../helper/Constants";
import * as Constants from "../../helper/Constants";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Images from "../../components/images";

export default class MatchCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sports_id: Constants.AppSelectedSport,
            timerCallback : this.props.timerCallback,
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if(nextProps != this.props){
            this.setState({
                timerCallback : nextProps.timerCallback
            })
        }

    }
    

    render() {
        const { item, gotoDetails,gotoLeaderBoard,isFromFreeToPlayLandingPage} = this.props;
        let sponserImage = item.sponsor_logo && item.sponsor_logo!=null ? item.sponsor_logo : 0

        return (
            <MyContext.Consumer>
                {(context) => (
                    <div className={"fixture-card-wrapper cursor-pointer " + (this.props.fixtureCardLg ? ' fixture-card-wrapper-lg' : '')} onClick={(event) => gotoDetails(item, event)}>
                        <div className="fixture-card-body display-table">
                            {
                                item.custom_message != '' && item.custom_message != null &&
                                <div className="announcement-custom-msg-wrapper">
                                    <OverlayTrigger trigger={['click']} placement="left" overlay={
                                            <Tooltip id="tooltip" className="tooltip-featured">
                                                 <strong>{item.custom_message} </strong> 
                                            </Tooltip>
                                        }>
                                        <i className="icon-megaphone" onClick={(e)=>e.stopPropagation()}></i>
                                    </OverlayTrigger>
                                </div>
                            
                            }

                            <MatchInfo item={item} timerCallback={this.state.timerCallback} />
                        </div>
                        <div className={"fixture-card-footer" + (item.league_name ? '' : ' justify-center') +(SELECTED_GAMET == Constants.GameType.Free2Play ? ' height-league-card' :'')}>
                            {item.league_name &&
                                <div className="match-type">
                                    {item.league_name || item.league_abbr} 
                                    {/* {this.state.sports_id === '7' &&
                                        <span> - {MATCH_TYPE[item.format]}</span>
                                    } */}
                                </div>
                            }
                            {
                                process.env.REACT_APP_LOBBY_WINNING_ENABLE == 1 &&
                                <div className="winning-section">
                                { SELECTED_GAMET == Constants.GameType.Free2Play  ? 
                                    
                                    
                                        window.ReactNativeWebView  ?
                                        <a 
                                            href
                                            onClick={(event)=>Utilities.callNativeRedirection(Utilities.getValidSponserURL(item.sponsor_link,event))}
                                            className="attached-url">
                                            <img alt='' className="lobby_sponser-image" style={{resizeMode: 'contain'}} src={sponserImage == 0 ?Images.BRAND_LOGO_FULL_PNG : Utilities.getSponserURL(sponserImage)}/>
                                        </a>
                                    
                                        :
                                        <a 
                                            href={Utilities.getValidSponserURL(item.sponsor_link)}
                                            onClick={(event)=>event.stopPropagation()}
                                            target='__blank'
                                            className="attached-url">
                                            <img alt='' className="lobby_sponser-image" style={{resizeMode: 'contain'}} src={sponserImage == 0 ?Images.BRAND_LOGO_FULL_PNG : Utilities.getSponserURL(sponserImage)}/>
                                        </a>
                                    
                                :
                                item.total_prize_pool > 0 ?
                                        <div className="collection-list-prize-pool">{AppLabels.WINNINGS}&nbsp;<span> {Utilities.getMasterData().currency_code + Utilities.kFormatter(item.total_prize_pool)}</span></div> : ''
                                    
                                }
                               </div>
                            }
                           
                        </div>
                        {
                            SELECTED_GAMET == Constants.GameType.Free2Play && !isFromFreeToPlayLandingPage &&
                            <div className ="free-to-play-info no-margin" onClick={(event) => gotoLeaderBoard(item, event)}>
                                <img alt='' src={Images.HALL_OF_FAME_SMALL_ICON} className="hall-of-fame-img"/>
                                  <div  className="text_hall_of_fame">
                                    {AppLabels.GAIN_POINTS}
                                </div>
                                <img alt='' src={Images.IC_INFO} className="icon-info"></img>

                                   </div>


                        }

                    </div>
                )}
            </MyContext.Consumer>
        )
    }
}